import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { CREDIT_CARD_OFFER_FIELDS_FRAGMENT } from '@repo/contracts/marketplace/offers/query';
import gql from 'graphql-tag';
import type {
  BalanceTransferRecommendationsQuery,
  BalanceTransferRecommendationsQueryVariables,
  BuildingCreditRecommendationsQuery,
  BuildingCreditRecommendationsQueryVariables,
  CashbackRecommendationsQuery,
  CashbackRecommendationsQueryVariables,
  SavingOnInterestRecommendationsQuery,
  SavingOnInterestRecommendationsQueryVariables,
  TravelRecommendationsQuery,
  TravelRecommendationsQueryVariables,
} from './__generated__/graphql';

const RECOMMENDATIONS_RESPONSE_FRAGMENT = gql`
  fragment RecommendationsResponseFields on RecommendationsResponse {
    __typename
    ... on RecommendationsResult {
      offers {
        offer {
          ...CreditCardOfferFields
        }
        score
        rank
        categoryScore
        scoreBreakdown {
          key
          value
        }
      }
      categories {
        id
        offerIds
      }
    }
    ... on RecommendationsError {
      code
      message
    }
  }
  ${CREDIT_CARD_OFFER_FIELDS_FRAGMENT}
`;

export const TRAVEL_RECOMMENDATIONS_QUERY: TypedDocumentNode<
  TravelRecommendationsQuery,
  TravelRecommendationsQueryVariables
> = gql`
  query TravelRecommendations($input: TravelRecommendationsInput!) {
    travelRecommendations(input: $input) {
      ...RecommendationsResponseFields
    }
  }
  ${RECOMMENDATIONS_RESPONSE_FRAGMENT}
`;

export const CASHBACK_RECOMMENDATIONS_QUERY: TypedDocumentNode<
  CashbackRecommendationsQuery,
  CashbackRecommendationsQueryVariables
> = gql`
  query CashbackRecommendations($input: CashbackRecommendationsInput!) {
    cashbackRecommendations(input: $input) {
      ...RecommendationsResponseFields
    }
  }
  ${RECOMMENDATIONS_RESPONSE_FRAGMENT}
`;

export const BALANCE_TRANSFER_RECOMMENDATIONS_QUERY: TypedDocumentNode<
  BalanceTransferRecommendationsQuery,
  BalanceTransferRecommendationsQueryVariables
> = gql`
  query BalanceTransferRecommendations($input: BalanceTransferRecommendationsInput!) {
    balanceTransferRecommendations(input: $input) {
      ...RecommendationsResponseFields
    }
  }
  ${RECOMMENDATIONS_RESPONSE_FRAGMENT}
`;

export const SAVING_ON_INTEREST_RECOMMENDATIONS_QUERY: TypedDocumentNode<
  SavingOnInterestRecommendationsQuery,
  SavingOnInterestRecommendationsQueryVariables
> = gql`
  query SavingOnInterestRecommendations($input: SavingOnInterestRecommendationsInput!) {
    savingOnInterestRecommendations(input: $input) {
      ...RecommendationsResponseFields
    }
  }
  ${RECOMMENDATIONS_RESPONSE_FRAGMENT}
`;

export const BUILDING_CREDIT_RECOMMENDATIONS_QUERY: TypedDocumentNode<
  BuildingCreditRecommendationsQuery,
  BuildingCreditRecommendationsQueryVariables
> = gql`
  query BuildingCreditRecommendations($input: BuildingCreditRecommendationsInput!) {
    buildingCreditRecommendations(input: $input) {
      ...RecommendationsResponseFields
    }
  }
  ${RECOMMENDATIONS_RESPONSE_FRAGMENT}
`;
